import React, { useState } from "react"
import { Button, Descriptions, Divider, Drawer, Popconfirm, Typography, message } from "antd"
import ShowKnifeInfo from "../../../../components/Knives/ShowKnifeInfo"
import { deleteDoc, doc, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import { useAuthContext } from "../../../../hooks/useAuthContext"

const { Link } = Typography
export default function CutterDetails(props) {
  const { user } = useAuthContext()
  const { order } = props
  const [open, setOpen] = useState(false)
  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //send forward order
  const handleSendForwardOrder = async () => {
    try {
      const orderRef = doc(db, "orders", order.id) // Assuming the collection is named 'orders'

      await updateDoc(orderRef, {
        orderStatus: 2,
        updatedBy: user.uid,
        updatedByEmail: user.email,
      })

      message.success("Updated!")
    } catch (error) {
      message.error("Error updating order:", error)
    }
  }

  //delete order
  const handleDeleteOrder = async () => {
    try {
      const orderRef = doc(db, "orders", order.id) // Assuming the collection is named 'orders'

      await deleteDoc(orderRef)

      message.success("Order successfully deleted!")
    } catch (error) {
      message.error("Error deleting order:", error)
    } finally {
      setOpen(false)
    }
  }

  return (
    <div>
      <Link type="primary" onClick={showDrawer}>
        View
      </Link>
      <Drawer
        title={order.selectedProduct.product.productName}
        placement="right"
        onClose={onClose}
        open={open}>
        <Divider>Blanks Order</Divider>
        <Descriptions column={1} title="Label info">
          <Descriptions.Item label="Knife Number">
            <ShowKnifeInfo props={order.selectedProduct} />
          </Descriptions.Item>
          <Descriptions.Item label="Label Width">
            {order.selectedProduct.labelWidth}
          </Descriptions.Item>
          <Descriptions.Item label="Label Height">
            {order.selectedProduct.labelHeight}
          </Descriptions.Item>
          <Descriptions.Item label="Number of Columns">
            {order.selectedProduct.numberOfColumns}
          </Descriptions.Item>
          <Descriptions.Item label="Material">{order.selectedProduct.material}</Descriptions.Item>
          <Descriptions.Item label="Label Count">{order.labelCount}</Descriptions.Item>
          <Descriptions.Item label="Client">{order.client.client}</Descriptions.Item>
          <Descriptions.Item label="Manager">{order.user}</Descriptions.Item>
          <Descriptions.Item label="Manager Comment">{order.salesComment}</Descriptions.Item>
        </Descriptions>

        <Divider>Action</Divider>

        <Button type="primary" style={{ marginBottom: 15 }} block onClick={handleSendForwardOrder}>
          Send Forward
        </Button>
        <Popconfirm
          title="Delete order?"
          description="Are you sure to delete this order?"
          onConfirm={handleDeleteOrder}
          okText="Yes"
          cancelText="No">
          <Button block danger>
            Delete
          </Button>
        </Popconfirm>
      </Drawer>
    </div>
  )
}
